import { Box, Stack, styled, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useAuthContext } from "hooks/useAuthContext";
import { MobileHeader2, UserEditStyledTextTypography } from "@theme/styledComponents";
import { styledConstants } from "@theme/styledConstants";

const StyledBox = styled(Box)(() => ({
    marginTop: styledConstants.Header2TopMargin,
}));

export const MobileOrganizationInfoSection = (props: {
    organizationName: string,
    userRole: string,
    patronNames: string[],
    tagA: string,
    tagB: string
}) => {
    const { userState } = useAuthContext();
    const { t } = useTranslation();

    return (
        <StyledBox>
            <MobileHeader2>{t("profile.yourPlaceInOrganization")}</MobileHeader2>
            <Stack marginTop={2} spacing={2}>
                <Stack>
                    <Typography variant="caption" color="text.secondary">{t("general.organization")}</Typography>
                    <UserEditStyledTextTypography>
                        {props.organizationName ?? userState.user.selectedWorkspace.workspaceName}
                    </UserEditStyledTextTypography>
                </Stack>
                <Stack>
                    <Typography variant="caption" color="text.secondary">{t("general.role")}</Typography>
                    <UserEditStyledTextTypography>
                        {t(`roles.${props.userRole}`)}
                    </UserEditStyledTextTypography>
                </Stack>
                <Stack>
                    <Typography variant="caption" color="text.secondary">{t("general.patron")}</Typography>
                    {props.patronNames.length > 0
                        ? props.patronNames.map((name, index) => (
                            <UserEditStyledTextTypography key={index}>{name}</UserEditStyledTextTypography>
                        ))
                        : <UserEditStyledTextTypography>{t("general.none")}</UserEditStyledTextTypography>
                    }
                </Stack>
                {props.tagA && (
                    <Stack>
                        <Typography variant="caption" color="text.secondary">{t("general.tagA")}</Typography>
                        <UserEditStyledTextTypography>{props.tagA}</UserEditStyledTextTypography>
                    </Stack>
                )}
                {props.tagB && (
                    <Stack>
                        <Typography variant="caption" color="text.secondary">{t("general.tagB")}</Typography>
                        <UserEditStyledTextTypography>{props.tagB}</UserEditStyledTextTypography>
                    </Stack>
                )}
            </Stack>
        </StyledBox>
    );
};
